export enum Columns {
  Actions = 'actions',
  Customers = 'customers',
  Subscription = 'subscription',
  Usage = 'usage',
  ValidUntil = 'validUntil',
}
